import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CertificateofInsuranceList = Loadable(
  lazy(() =>
    import("./CertificateofInsuranceList").then(
      ({ CertificateOfInsuranceList }) => ({
        default: CertificateOfInsuranceList,
      }),
    ),
  ),
);

const CommAutoCSIOCertificate = Loadable(
  lazy(() =>
    import("../CommCSIOCertificate/CommCSIOCertificate").then(({ CommAutoCSIOCertificate }) => ({
      default: CommAutoCSIOCertificate,
    }))
  )
);

const CommAutomobileCertificateInsurance = Loadable(
  lazy(() =>
    import(
      "../CommAutomobileCertificateInsurance/CommAutomobileCertificateInsurance"
    ).then(({ CommAutomobileCertificateInsurance }) => ({
      default: CommAutomobileCertificateInsurance,
    }))
  )
);


export const commAutoCertificateOfInsuranceRouter = [
  {
    path: `/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CertificateofInsuranceList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability-insurance/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate isDuplicate />
      </AuthorizedRoute>
    ),
  },
   {
      path: `/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance`,
      exact: true,
      element: (
        <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          <CommAutomobileCertificateInsurance />
        </AuthorizedRoute>
      ),
    },
    {
      path: `/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance/:serialNumber`,
      exact: true,
      element: (
        <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          <CommAutomobileCertificateInsurance />
        </AuthorizedRoute>
      ),
    },
    {
      path: `/comm-automobile-policy/:customerId/certificate-of-insurance/:customerPolicyId/certificate-of-insurance/duplicate/:serialNumber`,
      exact: true,
      element: (
        <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          <CommAutomobileCertificateInsurance isDuplicate />
        </AuthorizedRoute>
      ),
    },
];
